import { makeStyles } from '@material-ui/core';

type Props = {
  isLoading: boolean;
};

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: '24px',
    position: 'relative',
    marginTop: '1rem'
  },
  pageTitle: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    lineHeight: '1.5',
    marginBottom: '8px'
  },
  formContent: {
    margin: '0 30px',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  loading: ({ isLoading }: Props) => ({
    left: 0,
    top: 0,
    zIndex: 1,
    position: 'absolute',
    width: '100%',
    height: '100%',
    opacity: 0.6,
    background: 'white',
    display: isLoading ? 'grid' : 'none',
    placeItems: 'center'
  })
}));
